export default function MapPinCircle() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#18181B' />
      <path
        d='M17 10.4C17 14.2 12 18 12 18C12 18 7 14.2 7 10.4C7 8.70261 7.63214 7.07475 8.75736 5.87452C9.88258 4.67428 11.4087 4 13 4C14.5913 4 16.1174 4.67428 17.2426 5.87452C18.3679 7.07475 19 8.70261 19 10.4H17Z'
        stroke='#A1A1AA'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z'
        stroke='#A1A1AA'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
